import { Application } from '../../../accounts-management/applications/types';
import { PlatformServicePlanType } from '@flexinet/ui-components';
export type { Application };

export enum ProductStatus {
    Active = 'Active',
    Deprecated = 'Deprecated',
    Draft = 'Draft'
}

export type ProductFeature = {
    id: string,
    name: string,
    description?: string
}

export type ProductLineItem = {
    id: string,
    productId: string
    product: Product,
    productFeatureId: string
    productFeature: ProductFeature,
    position: number,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}

export type Price = {
    id: string,
    productId: string,
    amount: number,
    billingPeriod: string,
    stripePriceId?: string
}

export type Product = {
    id: string,
    name: string,
    status: ProductStatus,
    shortDescription?: string,
    longDescription?: string,
    productImage?: string,
    billingProviderId?: string,
    billingProviderRecordId?: string,
    current?: boolean,
    baseFee?: string,
    included?: string,
    prices?: {
        items: Price[],
        nextToken: string | null
    },
    lineItems?: {
        items: ProductLineItem[],
        nextToken: string | null
    },
    freeTrial?: boolean
    createdByUsername?: string,
    createdBy?: { username: string, givenName: string, familyName: string },
    created?: string,
    updated?: string,
}

export type ApplicationProduct = {
    id: string;
    applicationId: string;
    productId: string;
    product?: Product;
    applicationProductStatus?: 'ACTIVE' | 'INACTIVE';
    position?: number;
};

export type ApplicationWithPlans = {
    application: Application;
    products: Product[];
    subscribedProductId?: string;
};

export type ListProducts = {
    listProducts: { items: Product[], nextToken: string }
}

export type GetProduct = {
    getProduct: Product
}

export type ListApplicationProducts = {
    listApplicationProducts: { items: ApplicationProduct[], nextToken: string }
}

export const toServicePlan = (product: Product, prices?: { amount: number; billingPeriod: string }[]): PlatformServicePlanType => ({
    id: product.id,
    name: product.name,
    description: product.shortDescription,
    freeTrial: product.freeTrial,
    status: product.status,
    prices: prices,
    features: product.lineItems?.items
        ?.sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
        .map(item => ({ title: item.productFeature?.name ?? '', supported: true }))
        .filter(f => f.title),
});
